module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"all_templates":"从爆款短篇模版开始你的创作之旅～","market_recommend":"市场推荐"},"en":{"all_templates":"All Templates","market_recommend":"Market Recommend"}}')
  delete Component.options._Ctor
}
